module.exports = "/_next/static/files/a3b2667d6983bdd18464e057ff461c35.jpg";